import React from 'react';
import AdminHeader from '../../src/admin/layout/containers/AdminHeader';
import AdminNavbar from '../../src/admin/layout/components/AdminNavbar';
import AdminLayout from '../../src/admin/layout/components/AdminLayout';
import RobotsSettings from '../containers/RobotsSettings';
import Settings from '../components/Settings';

const propTypes = {};

const defaultProps = {};

const RobotsSettingsEdit = () => {
  const header = (
    <AdminHeader title="Settings" />
  );

  const navbar = (
    <AdminNavbar />
  );

  return (
    <AdminLayout
      header={header}
      navbar={navbar}
    >
      <Settings>
        <RobotsSettings />
      </Settings>
    </AdminLayout>
  );
};

RobotsSettingsEdit.propTypes = propTypes;
RobotsSettingsEdit.defaultProps = defaultProps;

export default RobotsSettingsEdit;
